module.exports = __webpack_public_path__ + "static/media/tl-PH.6e5be616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/tl-PH.png
// module id = 958
// module chunks = 0